export default __webpack_public_path__ + "static/calculator-2f90c44be2b3ff6617db737b522ae65a.gif";